import React, { useState } from 'react';
import { withTranslation } from 'react-i18next';
import Checkbox from '../Form/Checkbox';
import TextField from '../Form/TextField';
import { FormError } from '../Form/errors';
import LoadingOverlay from '../Helper/LoadingOverlay';

export const TOTPForm = withTranslation()(({ t, onSubmit, onBack, loading = false, error }) => {
  const [code, setCode] = useState('');
  const [rememberDevice, setRememberDevice] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (onSubmit) {
      onSubmit(code, rememberDevice);
    }
  };

  return (
    <div className="totp-wrapper wrapper-shrink">
      <LoadingOverlay active={loading} />
      <h1 className="title">{t('Two-factor authentication')}</h1>
      <form onSubmit={handleSubmit} className="totp-form">
        <p>{t('Please enter the 6-digit code from your authenticator app.')}</p>
        {error && <FormError error={error} />}
        <div className="form-group">
          <TextField
            autoFocus
            id="totp-code-input"
            inputName="totp-code-input"
            type="text"
            inputMode="numeric"
            pattern="[0-9]*"
            value={code}
            onChange={(e) => setCode(e.target.value.replace(/\D+/g, '').slice(0, 6))}
            label={t('Authenticator code')}
            disabled={loading}
          />
        </div>

        <Checkbox
          inputName="totp-remember-device"
          value={rememberDevice}
          onChange={() => setRememberDevice(!rememberDevice)}
          label={t('Remember this device for 30 days')}
        />

        <button type="submit" className="button btn-active" disabled={loading || !code || code.length < 6}>
          {t('Verify code')}
        </button>
      </form>
      <button type="button" className="button button-text back-button" onClick={onBack}>
        {t('Back to sign in')}
      </button>
    </div>
  );
});
